export { default as Candidate } from './candidate/candidate'
export { default as Carousel } from './carousel/carousel'
export { default as Founder } from './founder/founder'
export { default as LoanProcess } from './loan-process/loan-process'
export { default as Metrics } from './metrics/metrics'
export { default as Simulation } from './simulation/simulation'
export { StepCadastro } from './steps/step-cadastro'
export { StepEndereco } from './steps/step-endereco'
export { StepAcesso } from './steps/step-acesso'
export { default as FgtsSimulation } from './simulation/fgts-simulation'
export { default as Team } from './team/team'
export { default as Terms } from './terms/terms'
export { default as Warning } from './warning/warning'
